import spainPNG from './img/languages/spain.png';
import portugalPNG from './img/languages/portugal.png';

const itemsOnPage = [10, 25, 50, 100].map(item => ({
  key: item,
  value: item,
  renderElement: item,
  selectedRenderElement: item,
  active: item === 10,
}));

const statuses = [
  ['new', 'new'],
  ['processing', 'processing'],
  ['sent', 'sent'],
  ['completed', 'completed'],
].map(([value, text]) => ({
  key: value,
  value: value,
  renderElement: text,
  selectedRenderElement: text,
  active: false,
}));

const allowedBonusPromoIds = [64];

const checkBonusPromoAllowed = authData => allowedBonusPromoIds.includes(authData?.id);

const allowedDomainsParentIds = [62, 64];

const normalizeId = id => {
  if (id === null || id === undefined || id === '') return null;
  if (typeof id === 'string' && id.trim() === '') return null;

  const parsedId = Number(id);

  return Number.isFinite(parsedId) ? parsedId : null;
};

const getParentAgentId = authData =>
  normalizeId(
    authData?.parentAgentId ?? authData?.parent_agent_id ?? authData?.parentAgent?.id ?? authData?.parent_agent?.id,
  );

const checkDomainsAllowed = authData => {
  const authId = normalizeId(authData?.id);

  if (allowedDomainsParentIds.includes(authId)) return true;

  const parentAgentId = getParentAgentId(authData);

  return allowedDomainsParentIds.includes(parentAgentId);
};

export const searchInItems = [
  {
    name: 'allLanguages',
    value: 'allLanguages',
  },
  {
    name: 'all',
    value: 'all',
  },
  {
    name: 'spanish',
    value: 'es',
    icon: spainPNG,
  },
  {
    name: 'portuguese',
    value: 'pt',
    icon: portugalPNG,
  },
];

export { itemsOnPage, statuses, checkBonusPromoAllowed, checkDomainsAllowed };
